import { Action, Reducer } from "redux";
import { CultureState, CultureTypes, CultureActionTypes } from "./cultureTypes";

export const INITIAL_STATE: CultureState = {
	culture: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const cultureReducer: Reducer<CultureState> = (state: CultureState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as CultureActionTypes;
	switch (actionTypes.type) {
		case CultureTypes.GET_CULTURE:
			return {
				...state,
				culture: { ...state.culture, isLoading: true },
			};
		case CultureTypes.SAVE_CULTURE:
			return {
				...state,
				culture: {
					...state.culture,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case CultureTypes.RESET_REDUCER_CULTURE:
			return {
				...state,
				culture: INITIAL_STATE.culture,
			};
		default:
			return state;
	}
};

export default cultureReducer;
